import { Combobox, ComboboxInput, ComboboxPopupContainer } from "@angular/aria/combobox";
import { Listbox, Option } from "@angular/aria/listbox";
import { AsyncPipe, CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { OverlayModule } from '@angular/cdk/overlay';
import { Grund } from "../../../../Api/DcoApi/AktenEintraege/Grund";
import { switchMap, of, filter, from, Observable, OperatorFunction } from 'rxjs';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { RestClient } from "../../../../Api/DcoApi/Client/RestClient";
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap/typeahead';
import {
  afterRenderEffect,
  effect,
  Component,
  Directive,
  computed,
  signal,
  viewChild,
  viewChildren, Input, Output, EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';


@Component({
  imports: [
    Combobox,
    ComboboxInput,
    ComboboxPopupContainer,
    Listbox,
    Option,
    OverlayModule,
    FormsModule,
    AsyncPipe,
    CommonModule,
    NgbTypeahead
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'AbsetzungGrundSelect',
  templateUrl: './GrundSelect.html',
  standalone: true,
  styleUrl: './GrundSelect.css'
})
export class AbsetzungGrundSelect {
  Client: RestClient = new RestClient();


  Data: Grund[] = [];
  formatter = (x: Grund) => x.bezeichnung;
  @Input() selection: Grund | null | undefined = null;
  @Input() Text: string | null | undefined = null ;
  // MUST be named exactly 'addressChange' for [(address)] to work
  @Output() selectionChange = new EventEmitter<Grund | null| undefined>();
  @Output() TextChange = new EventEmitter<string | null | undefined>();

  // Event-Handler für die Auswahl im Combobox/Listbox
  onValueChangeEvent(selectedGrund: Grund) {
    console.log(selectedGrund);


    if (selectedGrund &&
      (!this.selection ||
        this.selection == null ||
        (selectedGrund.key > 0 &&
          this.selection &&
          this.selection != null
          &&
          (!this.selection ||
            this.selection == null ||
            (this.selection.key != selectedGrund.key)
          )
        ) ||
        (this.Text != selectedGrund.bezeichnung)
      )
    ) {

      if(selectedGrund.key > 0)
      {
        this.selectionChange.emit(selectedGrund);
      }
      else
      {
        this.TextChange.emit(selectedGrund.bezeichnung);
      }
    }
  }

  private readonly EMPTY_GRUND: Grund = { bezeichnung: "", key: -1 };

  get CurrentSelected(): Grund | undefined {

    if (this.selection && this.selection?.key > 0)
      return this.Data.find(g => g.key === this.selection?.key) || this.selection;

    if (this.Text && this.Text !== null && this.Text !== "") {
      this.EMPTY_GRUND.bezeichnung = this.Text;
    }
    else
      this.EMPTY_GRUND.bezeichnung = "";

    return this.EMPTY_GRUND;

  }




  constructor() {

    this.loadData();
    effect(() => {

    });


  }

  async loadData()
  {
    this.Data = await this.Client.Get<Grund[]>('/Absetzung/Gruende');
  }

  search: OperatorFunction<string, readonly Grund[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map((term) =>
        this.Serach(term)
      ),
    );

  protected Serach(querry: string): Grund[] {

    var result = this.Data.filter(g => querry == '' || g.bezeichnung?.toLowerCase().includes(querry?.toLowerCase()));

    if (querry !== '' && querry !== ' ' && querry != null) {

      result = [{ bezeichnung: querry, key: -1 } as Grund].concat(result)
    }

      return result;

  }

}
